export default "__VITE_ASSET__BcPBr9L4__"